import { render } from "./appTopicInfo.vue?vue&type=template&id=c665774c&scoped=true"
import script from "./appTopicInfo.vue?vue&type=script&lang=js"
export * from "./appTopicInfo.vue?vue&type=script&lang=js"

import "./appTopicInfo.vue?vue&type=style&index=0&id=c665774c&scoped=true&lang=css"

import exportComponent from "E:\\edu-ui\\JzEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c665774c"]])

export default __exports__